import React, { FunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { SortType } from '../MenuUtils';
import { LOCAL_STORAGE_SORTING_KEY } from '../../../common/constants';

interface Props {
  setSorting: (sortType: SortType) => void;
  sorting: SortType;
}

export const MenuSorting: FunctionComponent<Props> = ({ setSorting, sorting }) => {
  const { t } = useTranslation('sharedComponents');
  // Recover previous sort settings
  useEffect(() => {
    const storedSorting = localStorage?.getItem(LOCAL_STORAGE_SORTING_KEY);
    const sorting = Object.values(SortType).find(item => item == storedSorting);
    if (sorting != undefined) {
      setSorting(sorting as SortType);
    }
  }, []);

  const setAndStoreSorting = (sortType: SortType) => {
    localStorage.setItem(LOCAL_STORAGE_SORTING_KEY, sortType.toString());
    setSorting(sortType);
  };

  return (
    <SortingContainer>
      <SortingTitle>{t('shared.menu.sort')} </SortingTitle>
      <SortingItem onClick={() => setAndStoreSorting(SortType.natural_sorting)} selected={sorting === SortType.natural_sorting}>
        {t('shared.menu.topSells')}
      </SortingItem>
      <SortingItem onClick={() => setAndStoreSorting(SortType.alphabetical_asc)} selected={sorting === SortType.alphabetical_asc}>
        <div>
          <span>A</span>
          <span>Z</span>
        </div>
        <Arrow>↓</Arrow>
      </SortingItem>
      <SortingItem onClick={() => setAndStoreSorting(SortType.alphabetical_desc)} selected={sorting === SortType.alphabetical_desc}>
        <div>
          <span>Z</span>
          <span>A</span>
        </div>
        <Arrow>↓</Arrow>
      </SortingItem>
    </SortingContainer>
  );
};

const SortingContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 5px;
  margin-bottom: 20px;

  > * {
    margin-right: 5px;

    &:last-child {
      margin-right: 0;
    }
  }

  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

const SortingTitle = styled.span`
  font-size: 12px;
  color: gray;
`;
const SortingItem = styled.span<{ selected: boolean }>`
  background-color: ${props => (props.selected ? '#323232' : '#f1f1f1')};
  padding: 5px;
  border-radius: 12px;
  text-transform: capitalize;
  cursor: pointer;
  transition: all 0.3s;
  color: ${props => (props.selected ? 'white' : 'black')};
  display: flex;
  align-items: center;
  font-size: 12px;
  column-gap: 5px;

  div {
    display: flex;
    flex-direction: column;

    span {
      font-size: 8px;
      line-height: 9px;
    }
  }

  img {
    height: 20px;
  }

  &:hover {
    background-color: #323232;
    color: white;
  }

  @media (max-width: 1024px) {
    font-size: 14px;
  }
`;

const Arrow = styled.span`
  font-size: 18px;
`;
